import CloseIcon from '@mui/icons-material/Close';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import DescriptionTwoToneIcon from '@mui/icons-material/DescriptionTwoTone';
import NotificationImportantTwoToneIcon from '@mui/icons-material/NotificationImportantTwoTone';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import { IconButton } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Paper, { PaperProps } from '@mui/material/Paper';
import clsx from 'clsx';
import Draggable from 'react-draggable';
import { ModeCalendar } from '../../pages/ListManyCalendars';

function PaperComponent(props: PaperProps) {
  return (
    <>
      <Draggable
        defaultClassName="hidden md:flex"
        handle="#draggable-dialog-title"
        cancel='[class*="MuiDialogContent-root"], #draggable-dialog-title button'
      >
        <Paper {...props} />
      </Draggable>

      {/* Mobile is not draggable */}
      <Draggable defaultClassName="md:hidden" disabled>
        <Paper {...props} />
      </Draggable>
    </>
  );
}

export type DraggableModalProps = {
  children: JSX.Element | JSX.Element[];
  title?: string;
  open: boolean;
  mode?: ModeCalendar;
  onClose: () => void;
  onDelete?: () => void;
  onOpenReport?: () => void;
  onReportAlert?: () => void;
  onJustificateChangeValue?: () => void;
};

export function DraggableModal({
  title = '',
  children,
  open,
  mode,
  onClose,
  onDelete,
  onOpenReport,
  onReportAlert,
  onJustificateChangeValue,
}: DraggableModalProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      hideBackdrop
      fullWidth
    >
      <DialogTitle
        className={clsx(
          'md:cursor-move m-0 p-1 bg-gray-f1',
          'grid grid-cols-1-auto-1 gap-2 items-center text-center'
        )}
        id="draggable-dialog-title"
      >
        <div className="flex justify-start">
          {onReportAlert && (
            <IconButton
              onClick={onReportAlert}
              title="Notificação ao professor"
            >
              <NotificationImportantTwoToneIcon color="warning" />
            </IconButton>
          )}
          {onJustificateChangeValue && (
            <IconButton
              onClick={onJustificateChangeValue}
              title="Justificar alteração de valores"
            >
              <CurrencyExchangeIcon color="warning" />
            </IconButton>
          )}
        </div>

        <span>{title}</span>

        <div className="flex justify-end">
          {onOpenReport && (
            <IconButton color="secondary" onClick={onOpenReport}>
              <DescriptionTwoToneIcon />
              <span className="text-sm">Relatório</span>
            </IconButton>
          )}
          {mode === ModeCalendar.edit && (
            <IconButton color="error" onClick={onDelete}>
              <DeleteTwoToneIcon />
            </IconButton>
          )}
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent className="scroll-table overflow-x-hidden">
        {children}
      </DialogContent>
    </Dialog>
  );
}
